// DIRTY Responsive pricing table JS

$( ".comparision ul" ).on( "click", "li", function() {
  var pos = $(this).index()+2;
  $(".compare tr").find('td:not(:eq(0))').hide();
  $('.compare td:nth-child('+pos+')').css('display','table-cell');
  $(".compare tr").find('.compare th:not(:eq(0))').hide();
  $('.comparision li').removeClass('active');
  $(this).addClass('active');
});

// Initialize the media query
  var mediaQuery = window.matchMedia('(min-width: 991px)');
  
  // Add a listen event
  mediaQuery.addListener(doSomething);
  
  // Function to do something with the media query
  function doSomething(mediaQuery) {    
    if (mediaQuery.matches) {
      $('.spancol').attr('colspan',5);
    } else {
      $('.spancol').attr('colspan',2);
    }
  }
  
  // On load
  doSomething(mediaQuery);

$('.collapsible').click(function() {
    var span = document.getElementById('collapsebutton');
	//$(this).find('span').toggleClass('glyphicon glyphicon-minus');
    if($(this).find('span').hasClass("glyphicon glyphicon-plus")){
    $(this).find('span').removeClass('glyphicon glyphicon-plus').addClass('glyphicon glyphicon-minus')
    txt = document.createTextNode("Close Plan Features");
    span.appendChild(txt);
    txt.parentNode.removeChild(txt.parentNode.childNodes[1]) 
    }else{
    $(this).find('span').removeClass('glyphicon glyphicon-minus').addClass('glyphicon glyphicon-plus')
    txt = document.createTextNode("Compare Plan Features");
    span.appendChild(txt);
    txt.parentNode.removeChild(txt.parentNode.childNodes[1]) 
    }

		 
});